const SeoHelper = {
  supplant: function (str, o) {
    return str?.replace(/{([^{}]*)}/g,
      function (a, b) {
        var r = o[b];
        return typeof r === 'string' || typeof r === 'number' ? r : '';
      }
    );
  },
  // SEO Rule Date Type Enum
  DateTypeEnum : {
    "0": 'YYYY-MM-DD',
    "1": 'DD/MM/YYYY',
    "2": 'MMMM D, YYYY',
    "3": 'MMMM D',
    "4": 'dddd, MMMM D, YYYY',
    "5": 'dddd, MMMM D'
  },
  addTrailingSlash: function (url, query) {
    if (query) {
      url = url.replace(location.search, "");
    }

    if (!url.endsWith("/")) {
      url += "/";
    }

    return url;
  }
}

export default SeoHelper;